import axios from "axios";

export async function treatMissingData(item) {
	try {
		const result = await axios.put(process.env.VUE_APP_API_BASE_URL + "/backoffice/missing-data/" + item._id + "/treated", {}, {
			headers: {
				'X-User-Token': localStorage.getItem("BACKOFFICE_TOKEN")
			}
		});
		return {
			redirect: "/missing_data",
			message: "La donnée a été marquée comme traitée."
		};
	}
	catch(err) {
		console.log("Error treatMissingData: ", err);
		throw "Problème. La donnée n'a pas pu être marquée comme traitée.";
	}
}
